var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 82,
    viewBox: "0 0 103 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.2985V65.3571C0 69.6195 1.69324 73.7073 4.70721 76.7213C7.72119 79.7353 11.809 81.4285 16.0714 81.4285H86.7686C91.031 81.4285 95.1188 79.7353 98.1328 76.7213C101.147 73.7073 102.84 69.6195 102.84 65.3571V19.2856L52.8771 44.8799C52.4235 45.1124 51.9211 45.2336 51.4114 45.2336C50.9017 45.2336 50.3993 45.1124 49.9457 44.8799L0 19.2985Z",
    fill: "#367AF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.2985V65.3571C0 69.6195 1.69324 73.7073 4.70721 76.7213C7.72119 79.7353 11.809 81.4285 16.0714 81.4285H86.7686C91.031 81.4285 95.1188 79.7353 98.1328 76.7213C101.147 73.7073 102.84 69.6195 102.84 65.3571V19.2856L52.8771 44.8799C52.4235 45.1124 51.9211 45.2336 51.4114 45.2336C50.9017 45.2336 50.3993 45.1124 49.9457 44.8799L0 19.2985Z",
    fill: "url(#paint0_linear_829_10347)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.2985V65.3571C0 69.6195 1.69324 73.7073 4.70721 76.7213C7.72119 79.7353 11.809 81.4285 16.0714 81.4285H86.7686C91.031 81.4285 95.1188 79.7353 98.1328 76.7213C101.147 73.7073 102.84 69.6195 102.84 65.3571V19.2856L52.8771 44.8799C52.4235 45.1124 51.9211 45.2336 51.4114 45.2336C50.9017 45.2336 50.3993 45.1124 49.9457 44.8799L0 19.2985Z",
    fill: "url(#paint1_linear_829_10347)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.2985V65.3571C0 69.6195 1.69324 73.7073 4.70721 76.7213C7.72119 79.7353 11.809 81.4285 16.0714 81.4285H86.7686C91.031 81.4285 95.1188 79.7353 98.1328 76.7213C101.147 73.7073 102.84 69.6195 102.84 65.3571V19.2856L52.8771 44.8799C52.4235 45.1124 51.9211 45.2336 51.4114 45.2336C50.9017 45.2336 50.3993 45.1124 49.9457 44.8799L0 19.2985Z",
    fill: "url(#paint2_linear_829_10347)",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0714C0 11.809 1.69324 7.72119 4.70721 4.70721C7.72119 1.69323 11.809 0 16.0714 0H86.7686C91.031 0 95.1188 1.69323 98.1328 4.70721C101.147 7.72119 102.84 11.809 102.84 16.0714V21.2143L52.8771 46.8086C52.4235 47.041 51.9211 47.1622 51.4114 47.1622C50.9017 47.1622 50.3993 47.041 49.9457 46.8086L0 21.2271V16.0714Z",
    fill: "url(#paint3_linear_829_10347)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_829_10347",
    x1: 66.4114,
    y1: 27.8571,
    x2: 90.7029,
    y2: 84.4328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#0094F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#0094F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_829_10347",
    x1: 36.7286,
    y1: 25.8256,
    x2: 10.9114,
    y2: 86.3742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#0094F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#0094F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_829_10347",
    x1: 78.5357,
    y1: 56.3614,
    x2: 82.7186,
    y2: 87.1928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2764E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_829_10347",
    x1: 30.5529,
    y1: -14.7643,
    x2: 62.0271,
    y2: 67.6671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#29C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4894FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bd33d497a5c424d94f38376aa20ff43c.svg";
export { ForwardRef as ReactComponent };